import React from 'react';
import { NavLink } from 'react-router-dom';
import { parseDashboardURL } from '@utils';

const DashboardLink = ({
  dashboard,
  className,
  activeClassName,
}) => (
  <NavLink
    key={dashboard.id}
    to={parseDashboardURL(dashboard)}
    className={className}
    activeClassName={activeClassName}
    title={dashboard.name}
    id={`tab-${dashboard.name}`.toLowerCase()}
  >
    <span>
      {dashboard.name}
    </span>
  </NavLink>
);

DashboardLink.defaultProps = {
  className: '',
  activeClassName: '',
};

export default DashboardLink;
